import React from 'react'
import AiActionExplainer from 'components/AiActionExplainer'

const ROWS = [
  ['What counts as an asset', 'The building’s equipment — lifts, boilers, generators, fire systems, pressure systems, air handling (HVAC) and the like. If it needs a regular inspection, service or certificate, it belongs here.'],
  ['What “AI detect” does', 'It reads the documents you’ve uploaded — operation & maintenance (O&M) manuals, certificates and inspection reports — works out which equipment they describe, and lists it for you. It only ever adds new items it finds. It never edits or removes anything you’ve already recorded.'],
  ['What “Scanning…” means', 'When you press AI detect, the scan runs quietly in the background and the button shows “Scanning…”. It can take up to a minute. You don’t have to wait on this screen — come back or refresh, and any new equipment will be here.'],
  ['What a “renewal chain” is', 'Every asset keeps a running chain of the documents that prove it’s safe and in date — for example a lift’s annual inspection, or a boiler’s service certificate. When one is close to running out we warn you, and the next document links onto the same chain, so each item keeps an unbroken, dated history.'],
]

const AssetRegisterExplainer = ({ label = 'How this works' }) => (
  <AiActionExplainer
    label={label}
    title='How the asset register works'
    lead={(
      <>
        This is a plain list of the physical equipment inside the building — the plant and machinery that has to be
        inspected, serviced or certified to stay safe and legal. We keep each item here so its paperwork never quietly
        lapses.
      </>
    )}
    rows={ROWS}
    tip={(
      <>
        <strong>Prefer to do it yourself?</strong> Press <em>Add manually</em> to record any piece of equipment straight
        away — you never have to wait for detection.
      </>
    )}
  />
)

export default AssetRegisterExplainer
